import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ButtonPrimary from "../../components/buttons/ButtonPrimary";
import { useDispatch } from "react-redux";
import { updateRestaurantConfig } from "../../redux/actions/config";
import InputText from "../../components/input/InputText";
import InputSelect from "../../components/input/InputSelect";
import { countryExt } from "../../data/countryExt";
import { emailValidation, passwordValidation, phoneOnChange, phoneValidation } from "../../functions/validations";
import { RecaptchaVerifier, getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { setnotification } from "../../redux/actions/styles";
import InputPassword from "../../components/input/InputPassword";
import logo from "../../media/logo.webm";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../config/firebaseConfig";
import { useNavigate } from "react-router-dom";
import { logOut, signIn } from "../../redux/actions/auth";
import { COMPANY_DOMAIN, COMPANY_NAME, HOSTNAME } from "../../config/constants";
import SplashScreen from "../../layout/SplashScreen";
import { getFunctions, httpsCallable } from "firebase/functions";
import InputPrimary from "../../components/input/InputPrimary";
import bgImg from "../../media/images/login-bg.webp";

const InitialAuth = () => {
  const dispatch = useDispatch();
  const { restaurantConfig } = useSelector((state) => state.config);
  const { isAuthenticated } = useSelector((state) => state.auth);

  const navigate = useNavigate();

  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [loadingSubmit, setloadingSubmit] = useState(false);
  const [loading, setloading] = useState(true);

  useEffect(() => {
    if (!restaurantConfig && isAuthenticated) {
      navigate("/initial-setup");
      setloading(false);
    } else if (restaurantConfig && isAuthenticated) {
      navigate("/manage");
      setloading(false);
    } else {
      setloading(false);
    }
  }, []);

  const auth = getAuth();

  // async function onSave() {
  //   dispatch(
  //     updateRestaurantConfig({
  //       ...restaurantConfig,
  //     })
  //   );
  // }

  // const generateRecaptcha = () => {
  //   window.recaptchaVerifier = new RecaptchaVerifier(
  //     "recaptcha",
  //     {
  //       size: "invisible",
  //       callback: (response) => {
  //         // reCAPTCHA solved, allow signInWithPhoneNumber.
  //       },
  //     },
  //     auth
  //   );
  // };

  // const handleSend = () => {
  //   if (!emailValidation(email) || !ext || !phoneValidation(phone)) {
  //     dispatch(setnotification({ visible: true, text: "Enter valid credentials", type: "info" }));

  //     return;
  //   }
  //   generateRecaptcha();

  //   setisOTPScreen(true);

  //   let appVerifier = window.recaptchaVerifier;
  //   signInWithPhoneNumber(auth, `+${ext.value}${phone}`, appVerifier)
  //     .then((confirmationResult) => {
  //       // SMS sent. Prompt user to type the code from the message, then sign the
  //       // user in with confirmationResult.confirm(code).
  //       window.confirmationResult = confirmationResult;
  //       console.log(confirmationResult);
  //     })
  //     .catch((error) => {
  //       // Error; SMS not sent
  //       console.log(error);
  //     });
  // };

  // const verifyOtp = (event) => {
  //   let otp = event.target.value;
  //   setphoneOTP(otp);

  //   if (otp.length === 6) {
  //     // verifu otp
  //     let confirmationResult = window.confirmationResult;
  //     confirmationResult
  //       .confirm(otp)
  //       .then((result) => {
  //         // User signed in successfully.
  //         let user = result.user;
  //         console.log(user);
  //         alert("User signed in successfully");
  //         // ...
  //       })
  //       .catch((error) => {
  //         // User couldn't sign in (bad verification code?)
  //         // ...
  //         alert("User couldn't sign in (bad verification code?)");
  //       });
  //   }
  // };

  async function onSubmitForm(e) {
    e.preventDefault();

    if (!emailValidation(email) || !passwordValidation(password)) {
      dispatch(setnotification({ visible: true, text: "Enter valid credentials", type: "info" }));
      return;
    }

    setloadingSubmit(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      // Signed in
      const user = userCredential.user;
      const token = await user.getIdToken();

      const docRef = doc(db, "clients", user.email);
      const docSnap = await getDoc(docRef);

      let userData = null;

      if (!docSnap.exists()) {
        const functions = getFunctions();
        const setAdmin = httpsCallable(functions, "setAdminAccess");
        await setAdmin({ uid: user.uid, isAdmin: true });

        userData = {
          id: user.uid,
          email: user.email,
          role: "admin",
          domain: HOSTNAME,
        };

        await setDoc(doc(db, "clients", user.email), userData);
      } else {
        const data = docSnap.data();

        userData = {
          id: data.id,
          email: data.email,
          role: data.role,
          domain: data.domain,
        };
      }

      if (userData.domain !== HOSTNAME) {
        dispatch(logOut());
        dispatch(setnotification({ visible: true, text: "You are not authorized to this restaurant.", type: "error" }));
        return;
      }

      dispatch(
        signIn({
          user,
          userData,
        })
      );

      dispatch(setnotification({ visible: true, text: "You are successfully signed in.", type: "success" }));

      navigate("/initial-setup");

      // setTimeout(() => {
      //   push("/tools/chats");
      // }, 1000);

      // setloadingSubmit(false);
    } catch (error) {
      // ...
      const errorCode = error.code;
      const errorMessage = error.message;

      console.log(errorCode);

      // The email of the user's account used.
      // const email = error.customData.email;
      // The AuthCredential type that was used.

      if (errorCode === "auth/user-disabled") {
        dispatch(
          setnotification({
            visible: true,
            text: "Your account has been disabled, contact us to enable account.",
            type: "error",
          })
        );
      } else {
        dispatch(
          setnotification({
            visible: true,
            text: "Invalid credentials.",
            type: "error",
          })
        );
      }
    }
    setloadingSubmit(false);
  }

  if (loading) {
    return <SplashScreen />;
  }

  return (
    <div className="initial-auth">
      <div className="bg-img">
        <img src={bgImg} alt="background" />
      </div>
      <div className="add-user">
        <form onSubmit={onSubmitForm}>
          <h3 className="mb-4">User Login</h3>
          <InputPrimary
            className="mb-4"
            type="text"
            label="Username"
            name="email"
            value={email}
            onChange={(e) => setemail(e.target.value)}
          />
          <InputPrimary
            className="mb-5"
            type="password"
            label="Password"
            name="password"
            value={password}
            onChange={(e) => setpassword(e.target.value)}
          />
          <div className="action">
            <ButtonPrimary size="sm" className="w-100" text="Log In" onClick={onSubmitForm} loading={loadingSubmit} />
          </div>
        </form>
      </div>

      <div className="login-footer">
        <p>
          © {new Date().getFullYear()} –{" "}
          <a href={COMPANY_DOMAIN} target="_blank" rel="noreferrer">
            {COMPANY_NAME}
          </a>
          . All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default InitialAuth;
